(ns frontend.lp-portal.routes)

(def lp-routes
  "When adding a page here, don't forget to require the controller in the main of the application"
  ["/"
   ["" ::landing-page]
   ["archive" ::archive]
   ["contact-us" ::contact-us]
   ["disclaimer" ::disclaimer]
   ["glossary" ::glossary]
   ["logout" ::logout]
   ["loading/{status}" ::loading-error]
   ["report/{id}" ::report-view]
   ["news-item/create" ::news-item-create]
   ["promotion/create" ::promotion-create]
   ["news-item/edit/{id}" ::news-item-edit]
   ["promotion/edit/{id}" ::promotion-edit]
   ["opportunities" ::promotions]])
